import { Component, Inject, Input, OnInit } from '@angular/core';
import { IStateService } from 'angular-ui-router';
import { find, includes } from 'lodash';
import {
  ICurrentState,
  SchoolToolbarService,
} from '../../../app/layout/toolbars/school-toolbar/school-toolbar.service';
import { SpinnerModal } from '../../../app/shared/modals/status-spinner/status-spinner.service';
import { Iv3NavStates, v3NavStates } from '../../shared/constants/v3-nav-states.constant';
import { ImUser } from '../../shared/services/im-models/im-user';

type TValidStateSuffix = 'wizard' | 'grid' | 'profile';
interface ISdcNavLink {
  humanName: TValidStateSuffix;
  state: string;
}
@Component({
  selector: 'nvps-sdc-nav',
  template: require('./sdc-nav.component.html'),
  styles: [require('./sdc-nav.component.scss')],
})
export class SdcNavComponent implements OnInit {
  navs;
  sdcHeader;
  sdcStates;

  @Input() currentUser;
  @Input() currentState: ICurrentState;
  @Input() showExitButton: Boolean;

  constructor(
    @Inject('$state') private $state: IStateService,
    @Inject('SpinnerModal') private SpinnerModal: SpinnerModal,
    @Inject('SDCStore') private SDCStore,
    @Inject('SchoolToolbarService') private schoolToolbarService: SchoolToolbarService,
    private imUser: ImUser,
  ) {
    this.sdcStates = v3NavStates.v2;
  }

  ngOnInit() {
    const currentState: ICurrentState = this.currentState || this.schoolToolbarService.getCurrentState();
    this.navs = this.getNavLinks(currentState);
    this.sdcHeader = this.getSdcHeader(this.sdcStates);
  }

  // interface for v3 constant
  getSdcHeader(states: Iv3NavStates) {
    const header = find(states, (state: any) => {
      return this.$state.current.name.includes(state.sdcStateRoot);
    });
    return header.humanName;
  }

  currentSdcName(): string {
    return this.$state.current.name;
  }

  currentSuffix(): string {
    const currName = this.currentSdcName().split('.');
    return currName.pop();
  }

  isActiveState(state: string): boolean {
    return state === this.$state.current.name;
  }

  // Dynamically build navigation links based on current sdc/state
  getNavLinks(currentState: ICurrentState) {
    let navs: ISdcNavLink[] = [];
    const uiState = this.SDCStore.getUiState();
    // Not an SDC route
    if (!currentState.name && !currentState.name.includes('single-student')) {
      return [];
    }

    const availableViews = currentState.availableSdcViews || [];

    // For each SDC view type, if its included in the SDCState constant, include it in the nav.
    if (includes(availableViews, 'wizard')) {
      const state = uiState.currentActivity.state + '.wizard';
      navs.push(this.createNav(state, 'wizard'));
    }

    if (includes(availableViews, 'grid')) {
      const state = uiState.currentActivity.state + '.grid';
      if (currentState.name !== 'main.school.new-sdc.default-sdc.grid') {
        navs.push(this.createNav(state, 'grid'));
      }
    }

    // If currently on grid OR wizard push profile
    if (includes(availableViews, 'profile')) {
      const state = uiState.currentActivity.state + '.profile';
      if (currentState.name !== 'main.school.new-sdc.default-sdc.grid') {
        navs.push(this.createNav(state, 'profile'));
      }
    }

    return navs;
  }

  goToState(newState: string): void {
    this.SpinnerModal.activateSpinner('Changing view...');
    this.$state.go(newState);
  }

  createNav(state: string, view: TValidStateSuffix): any {
    const canAccessState = this.imUser.canAccessState(this.currentUser, state);
    if (canAccessState) {
      return {
        humanName: view,
        state,
      };
    } else {
      return {};
    }
  }
}
